// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AmountWithLabel_mainWrapper__i57du","header":"AmountWithLabel_header__bCJM9","wrapper":"AmountWithLabel_wrapper__ZJX2h","value":"AmountWithLabel_value__k8Jp1"};